import { Cog8ToothIcon, CreditCardIcon, UserPlusIcon, BookmarkIcon, DocumentIcon, SparklesIcon, ChatBubbleLeftRightIcon, QuestionMarkCircleIcon, DocumentTextIcon } from "@heroicons/react/24/outline"
import { Navigate, Route, Routes, } from "react-router-dom"
import { RouteElement } from "../../../interfaces/_common"
import { SubMenuTabs } from "../common"
import { GeneralSettings } from "./GeneralSettings"
import RouteKeys from "constants/route-keys"
import OnboardingSettings from "./OnboardingSettings"
import PaymentGatewaySettings from "./PaymentGatewaySettings"
import ResourceSettings from "./ResourceSettings"
import { AISettings } from "./AISettings"
import HelpSupportSettings from "./HelpSupportSettings"
import BookmarkSettings from "./BookmarkSettings"
import PillBannerSettings from "./PillBannerSettings"
import AskQuestionSettings from "./AskQuestionSettings"
import HTMLUploadSettings from "./HTMLUploadSettings"

const _routes: RouteElement[] = [
    {
        route: 'general-settings',
        title: 'General Settings',
        key: RouteKeys.GENERAL,
        component: GeneralSettings,
        icon: Cog8ToothIcon,
        display: true
    },
    {
        route: 'onboarding-settings',
        title: 'Onboarding Settings',
        key: RouteKeys.ONBOARDING_QUESTION_SETTINGS,
        component: OnboardingSettings, 
        icon: UserPlusIcon,
        display: true
    },
    {
        route: 'payment-settings',
        title: 'Payment Gateway Settings',
        key: RouteKeys.PAYMENT_GATEWAY,
        component: PaymentGatewaySettings, 
        icon: CreditCardIcon,
        display: true
    },
    {
        route: 'resource-settings',
        title: 'Resource Settings',
        key: RouteKeys.RESOURCE_SETTING,
        component: ResourceSettings, 
        icon: DocumentIcon,
        display: true
    },
    // {
    //     route: 'help-support-settings',
    //     title: 'Help & Support Settings',
    //     key: RouteKeys.HELP_SUPPORT_SETTINGS,
    //     component: HelpSupportSettings, 
    //     icon: ChatBubbleLeftRightIcon,
    //     display: true
    // },
    {
        route: 'ai-settings',
        title: 'AI Settings',
        key: RouteKeys.AI_SETTINGS,
        component: AISettings,
        icon: SparklesIcon,
        display: true
    },
    {
        route: 'bookmark-settings',
        title: 'Bookmark Settings',
        key: RouteKeys.BOOKMARK_SETTINGS,
        component: BookmarkSettings,
        icon: BookmarkIcon,
        display: true
    },
    {
        route: 'pill-banner-settings',
        title: 'Pill Banner Settings',
        key: RouteKeys.PILLBANNER_SETTINGS,
        component: PillBannerSettings,
        icon: DocumentIcon,
        display: true
    },
    {
        route: 'onboarding-question-settings',
        title: 'Onboarding Question',
        key: RouteKeys.ONBOARDING,
        component: AskQuestionSettings,
        icon: QuestionMarkCircleIcon,
        display: true
    },
    {
        route: 'html-upload-settings',
        title: 'HTML Upload',
        key: RouteKeys.HTML_UPLOAD_SETTINGS,
        component: HTMLUploadSettings,
        icon: DocumentTextIcon,
        display: true
    },
]

const Settings = () => {
    return (
        <div>
            <SubMenuTabs _routes={_routes}/>
            <div className="p-3">
                <Routes>
                    <Route path='' element={<Navigate to={_routes[0].route} replace/>}>
                    </Route>
                    {_routes.map(route => (
                        <Route path={route.route} key={'mediaListI' + route.route} element={<route.component />} />
                    ))}
                </Routes>
            </div>
        </div>
    )
}

export default Settings